import { useEffect, useState, useRef, useCallback } from "react";
import { get } from "utils/DeV2Api";

const useFetchResources = ({ url, params, fetchByDefault = true }) => {
  const subscribedPromises = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState();
  const [meta, setMeta] = useState();

  const fetchResources = useCallback(() => {
    setError(null);
    setIsLoading(true);
    const contentsPromise = get(url, {
      params: params,
    });
    contentsPromise.promise
      .then((response) => {
        setData(response?.data ?? []);
        setMeta(response?.meta ?? {});
      })
      .catch((error) => !error.isCanceled && setError(error))
      .finally(() => setIsLoading(false));
  }, [url, params?.page, params?.perPage]);

  useEffect(() => {
    if (fetchByDefault) fetchResources();

    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => {
        promise.cancel();
      });
    };
  }, [fetchResources, fetchByDefault]);

  return {
    data,
    meta,
    setData,
    error,
    setError,
    isLoading,
    fetchResources,
  };
};
export default useFetchResources;
